<template>
  <div 
    class="company-info-card mb-4 p-3 rounded shadow-sm"
    :class="{'offer-rejected': rejected}"
  >
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h5 
          class="company-name mb-1 cursor-pointer" 
          @click="openCompanyRateStatistics(company)"
        >
          <i class="fa fa-building-o mr-2 text-primary"></i>
          {{ company.name }}
        </h5>
        <div class="text-muted">
          <small>{{ $t('vendorAddModal.taxIdLabel') }} {{ company.taxId }}</small>
        </div>
      </div>
      <div v-if="rejected" class="rejected-badge">
        <span class="badge badge-danger py-2 px-3">
          <i class="fa fa-ban mr-1"></i> {{ $t('detailedComparisonModal.rejected') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyInfoCard",
  props: {
    company: {
      type: Object,
      required: true
    },
    rejected: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openCompanyRateStatistics(company) {
      this.$emit('open-company-rate-statistics', company);
    }
  }
};
</script>

<style scoped>
/* Company Info Card */
.company-info-card {
  background-color: #f8f9fa;
  border-left: 4px solid #007bff;
}

.company-name {
  font-size: 1.25rem;
  font-weight: 600;
  color: #343a40;
}

.rejected-badge .badge {
  font-size: 0.85rem;
  font-weight: 500;
}

.offer-rejected {
  background-color: #f9f9f9;
  opacity: 0.75;
}

.cursor-pointer {
  cursor: pointer;
}
</style>